<template>
  <textarea
    class="textarea"
    :class="{ 'textarea--error': error, 'textarea--disabled': disabled }"
    :id="id"
    :value="value"
    :placeholder="placeholder"
    :disabled="disabled"
    @input="$emit('input', $event.target.value)"
    @focus="$emit('focus')"
    @blur="$emit('blur')"
  ></textarea>
</template>

<script>
export default {
  name: 'Textarea',
  emits: ['input', 'focus', 'blur'],
  props: {
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    valid: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="sass">
@import "~@src/legacy/sass/params"

.textarea
  width: 100%
  min-height: 120px
  padding: 16px
  border: var(--field-border-width, 1px) solid var(--field-border-color, #C8C8C8)
  border-radius: 4px
  resize: vertical
  transition: border .2s

  &::placeholder
    color: var(--field-placeholder-color, $gray-text)

  &--error
    border: var(--field-error-border-width, 1px) solid var(--field-error-border-color, $error)

  &--disabled
    opacity: var(--field-opacity-disabled, 0.7)
    pointer-events: none
    background-color: var(--field-disabled-bg-color, #ededed)
</style>



// WEBPACK FOOTER //
// src/modules/shared/ui/public/forms/fields/Textarea.vue